"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ISO_DATE_FORMAT = exports.DEFAULT_DATE_INPUT_FORMAT = exports.DAY_ARRAY = void 0;
var ISO_DATE_FORMAT = 'yyyy-MM-dd';
exports.ISO_DATE_FORMAT = ISO_DATE_FORMAT;
var DEFAULT_DATE_INPUT_FORMAT = 'dd/MM/yyyy';
exports.DEFAULT_DATE_INPUT_FORMAT = DEFAULT_DATE_INPUT_FORMAT;
var DAY_ARRAY = {
  0: 'sun',
  1: 'mon',
  2: 'tue',
  3: 'wed',
  4: 'thu',
  5: 'fri',
  6: 'sat'
};
exports.DAY_ARRAY = DAY_ARRAY;